/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useInput, Labeled } from 'react-admin';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  label: {
    width: '35%',
  },
  input: {
    width: '80%',
  },
  chip: {
    width: '50px',
  },
});

const SliderInput = (props) => {
  const {
    input: { name, onChange, value },
  } = useInput(props);

  const { source, label, max, min, step, classes } = props;

  const handleChangeInput = (e) => {
    onChange(Number(e.target.value));
  };

  return (
    <Labeled className={classes.label} label={label || source}>
      <React.Fragment>
        {/* platform input due to strange behavior of material-ui slider with decimal this.setState
          TODO : theming */}
        <input
          name={name}
          type="range"
          max={max}
          min={min}
          step={step}
          value={value}
          onChange={handleChangeInput}
          className={classes.input}
        />
        <Chip label={value} className={classes.chip} />
      </React.Fragment>
    </Labeled>
  );
};

SliderInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  label: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
};

SliderInput.defaultProps = {
  record: {},
  label: null,
  max: 100,
  min: 0,
  step: null,
};

export default withStyles(styles)(SliderInput);
